import { EditIcon, ViewIcon } from '@components'
import cn from '@integrations/classnames'
import { MerchantAccessLevels } from 'mmfintech-backend-api'
import type { MerchantAccessLevel, Nullable } from 'mmfintech-backend-api/types'
import { tr } from 'mmfintech-commons'

import styles from './AccessLevelIcon.module.scss'

interface Props {
  level: Nullable<MerchantAccessLevel>
}

// Same split as the legacy staff "Account permissions" column: WRITER can initiate (pencil), anything else is view only (eye)
function AccessLevelIcon({ level }: Props) {
  // No level yet (access still loading): show nothing rather than flash "View only" before it flips to "Full"
  if (!level) {
    return null
  }

  const canWrite = level === MerchantAccessLevels.WRITER
  const label = canWrite
    ? tr('FRONTEND.USERS.EXPENSE_MANAGEMENT.DASHBOARD.ACCOUNT_OVERVIEW.FULL.TITLE', 'Full')
    : tr('FRONTEND.USERS.EXPENSE_MANAGEMENT.DASHBOARD.ACCOUNT_OVERVIEW.VIEW_ONLY', 'View only')

  return (
    <span
      className={cn(styles['access-level-icon'], 'access-level-icon')}
      role='img'
      aria-label={label}
      title={label}
      data-test={canWrite ? 'account-permission-initiate' : 'account-permission-view-only'}
    >
      {canWrite ? <EditIcon /> : <ViewIcon />}
    </span>
  )
}

export default AccessLevelIcon
